import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const getFaxes = (axios: IAxiosInstance) => {
  return async (params: ISchema["#/definitions/TGetFaxesQuery"]) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/TGetFaxesResponse"]
    >(`/api/getFaxes`, {
      params,
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
